import * as React from 'react';
import { HOC, HOCProps } from "./HOC";
import classNames from 'classnames';

declare type InputProps = React.InputHTMLAttributes<HTMLInputElement> & { top?: number };
export const Input = HOC<InputProps>(({ isTouched: touched, message, top, ...props }: HOCProps<InputProps>) => {
    const hasMessage = !!message;
    const iconClass = classNames({
        fa: true, "fluent-valid-icon": !hasMessage, "fa-check": !hasMessage,
        "fluent-invalid-icon": hasMessage, "fa-times": hasMessage
    });
    const controlClassName = hasMessage ? "fluent-invalid-control" : "fluent-valid-control";
    const { className, ...rest } = props
    return <React.Fragment>
        <input {...rest} className={`${controlClassName} ${className}`} />
        {(hasMessage || touched) && <i style={{ position: "absolute", right: 15, top: top || 33 }} className={iconClass} />}
        {hasMessage && <span className="fluent-invalid-feedback">{message}</span>}
    </React.Fragment>
}, "blur")